import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

const Meta = () => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      document.title =
        "Unicon Profile | Electrostatic Precipitator In Thermal Power Plant"; // Reset title if necessary
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <Helmet>
      <title>Unicon | Electrostatic Precipitator In Thermal Power Plant</title>
      <meta
        name="title"
        content="Unicon - Electrostatic Precipitator In Thermal Power Plant"
      />
      <meta
        name="description"
        content="UNICON excels in electrostatic precipitators for air pollution control, providing expert design, fabrication, and installation for peak performance."
      />
      <meta name="keywords" content="Custom Electrostatic Precipitator" />
      <meta name="robots" content="index,follow" />
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="language" content="English" />
      <meta
        property="og:title"
        content="Unicon - Electrostatic Precipitator In Thermal Power Plant"
      />
      <meta
        property="og:site_name"
        content="Unicon Electrostatic Precipitator"
      />
      <meta
        property="og:url"
        content="https://www.uniconinter.com/electrostatic-precipitator"
      />
      <meta
        property="og:description"
        content="UNICON excels in electrostatic precipitators for air pollution control, providing expert design, fabrication, and installation for peak performance."
      />
      <meta property="og:type" content="product" />
      <meta
        property="og:image"
        content="https://www.uniconinter.com/images/products/electrostatic-percipitators/esp-main.jpg"
      />
    </Helmet>
  );
};

export default Meta;
